import React from "react";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";

const Phone = (props) => {
    const { name, id, placeholder, value, className, style } = props;

    const handleChange = (event) => {
        const target = event.target;

        if (props.onChange) {
            props.onChange(name, target.value);
        }
    };

    const handleBlur = () => {
        if (props.onBlur) {
            props.onBlur(name, true);
        }
    };

    return (
        <MaskedInput
            type="text"
            inputMode="tel"
            autoComplete="tel-national"
            id={id ? id : name}
            name={name}
            value={value ? value : ""}
            mask={[
                "(",
                /[2-9]/,
                /\d/,
                /\d/,
                ")",
                " ",
                /\d/,
                /\d/,
                /\d/,
                "-",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
            ]}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={placeholder ? placeholder : ""}
            className={className ? className : ""}
            style={style ? style : {}}
        />
    );
};

Phone.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default Phone;
